import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LocalizeService } from '../../../shared/utils/localize.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'dmv-pub-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderComponent implements OnInit {

    @Input() public displayServiceUnavailable = false;
    @Input() public displayServiceUnavailableTekst;

    private query: MediaQueryList;
    private expandedSubject = new BehaviorSubject(null);
    public expanded$ = this.expandedSubject.asObservable();

    constructor(private localizeService: LocalizeService, private ref: ChangeDetectorRef) {
    }

    public ngOnInit(): void {
        this.query = window.matchMedia('(min-width: 768px');
        this.collapse();
        /**
         * Use addListener instead of addEventListener for compatibility
         * since MediaQueryList only inherits from EventTarget in newer browsers.
         */
        this.query.addListener(this.collapse);
    }

    public get home(): string {
        return 'Core.Crumbs.Home.Url';
    }

    public get crumbs(): { text: string, url: string }[] {
        switch (this.localizeService.getLanguage()) {
            case 'nl':
            case 'en':
                return [
                    {text: 'Core.Crumbs.Home.Text', url: 'Core.Crumbs.Home.Url'},
                    {text: 'Core.Crumbs.Mob.Text', url: 'Core.Crumbs.Mob.Url'},
                    {text: 'Core.Crumbs.Lez.Text', url: 'Core.Crumbs.Lez.Url'}
                ];
            case 'fr':
            case 'de':
                return [
                    {text: 'Core.Crumbs.Home.Text', url: 'Core.Crumbs.Home.Url'},
                    {text: 'Core.Crumbs.Lez.Text', url: 'Core.Crumbs.Lez.Url'}
                ];
        }
    }

    public expandCrumbs(e: Event): void {
        e.preventDefault();
        this.expandedSubject.next(true);
        this.ref.detectChanges();
    }

    public get expanded(): boolean {
        return (this.query.matches && this.crumbs.length > 5) || (!this.query.matches && this.crumbs.length > 2);
    }

    private collapse = (): void => {
        this.expandedSubject.next(!this.expanded);
        /**
         * For some reason the observable doesn't play nice with MediaQueryList.
         * DetectChagnes seems unavoidable.
         */
        this.ref.detectChanges();
    }
}
